<template>
	<div class="cols">
		<div class="cl ModalPrompt" style="flex:0 0 40%" >
			<h1>🚀</h1>
			<h1>Activate {{ dsplApostrophize(org.name) }} Configaro account:</h1>
      <p style="font-weight:700" class="t-big" >You are one click away from levelling up how your team manages and generates configs.</p>
      <ul>
        <li>No more mistakes made by copying and modifying old configs</li>
        <li>Share config templates with your team</li>
        <li>Make sure everyone is always using the latest template</li>
      </ul>
		</div>
		<div class="cl ModalBody">
      
      <AddOrUpdateSubscription
        v-if="!org.subscription.subscribed"
        :org="org"
        :onSuccess="onSuccess"
      />
      <div v-else >
        <p>Your account is already activated!</p>
        <p><button class="btn-a" @click="toBilling()" >Go to billing page</button></p>
      </div>
    
		</div>
	</div>
</template>

<script>

	import AddOrUpdateSubscription from '../components/AddOrUpdateSubscription';

	export default {
    components : {AddOrUpdateSubscription},
    props : ['org'],
    
		mounted() {
      Event.$emit('modal-resize','medium');
    },

		methods: {
      toBilling(){
        Event.$emit('modal-close');
        this.$router.push({name:'org.billing',params:{org_id:this.org.id}});
      },
			onSuccess : function(payload){
        Event.$emit('modal-close');
      },

		}
	}
</script>